// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery_pvAlf {
  max-width: 100%;
  padding: var( --size-padMedium );
  display: grid !important;
  grid-template-columns: repeat(auto-fill, minmax(280px,1fr));
  grid-auto-rows: minmax(162px, min-content);
  gap: var(--size-galleryGap, var(--size-padLarge));
}

.galleryNoData_DIPwV {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.galleryItem_Ckyd2 {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.toolbar_htPwT {
  position: absolute;
  z-index: 1;
}

.toolbarLeft_u2zqC {
  top: calc(var(--size-padMedium) + 4px);
  left: calc(var(--size-padMedium) + 6px);
}

.toolbarRight_HRLNc {
  top: calc(var(--size-padMedium));
  right: calc(var(--size-padMedium) + 6px);
}

.toolbars_EGFDJ {
  min-height: 58px;
}

.container_LNds3 {
  max-height: 100%;
  width: 100%;
}

.details_Rifu5 > div:first-child {
  background-color: transparent;
  border: none;
  padding: 0;
  flex-grow: 1;
}

.details_Rifu5 {
  width: 100%;
  container-type: inline-size;
  overflow: hidden;
}

.details_Rifu5 div, .details_Rifu5 button {
  font-size: min(var(--size-galleryDetailTextMin, 4.2cqi), var(--size-galleryDetailTextMax, 12px)) !important;
}

.details_Rifu5 > div > div > :nth-child(2) {
  grid-template-columns: auto minmax(0, 1fr) !important;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-rsrc-management/lib/components/rsrcGallery/Gallery.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gCAAgC;EAChC,wBAAwB;EACxB,2DAA2D;EAC3D,0CAA0C;EAC1C,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,2GAA2G;AAC7G;;AAEA;EACE,qDAAqD;AACvD","sourcesContent":[".gallery {\n  max-width: 100%;\n  padding: var( --size-padMedium );\n  display: grid !important;\n  grid-template-columns: repeat(auto-fill, minmax(280px,1fr));\n  grid-auto-rows: minmax(162px, min-content);\n  gap: var(--size-galleryGap, var(--size-padLarge));\n}\n\n.galleryNoData {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.galleryItem {\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n\n.toolbar {\n  position: absolute;\n  z-index: 1;\n}\n\n.toolbarLeft {\n  top: calc(var(--size-padMedium) + 4px);\n  left: calc(var(--size-padMedium) + 6px);\n}\n\n.toolbarRight {\n  top: calc(var(--size-padMedium));\n  right: calc(var(--size-padMedium) + 6px);\n}\n\n.toolbars {\n  min-height: 58px;\n}\n\n.container {\n  max-height: 100%;\n  width: 100%;\n}\n\n.details > div:first-child {\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  flex-grow: 1;\n}\n\n.details {\n  width: 100%;\n  container-type: inline-size;\n  overflow: hidden;\n}\n\n.details div, .details button {\n  font-size: min(var(--size-galleryDetailTextMin, 4.2cqi), var(--size-galleryDetailTextMax, 12px)) !important;\n}\n\n.details > div > div > :nth-child(2) {\n  grid-template-columns: auto minmax(0, 1fr) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gallery": `gallery_pvAlf`,
	"galleryNoData": `galleryNoData_DIPwV`,
	"galleryItem": `galleryItem_Ckyd2`,
	"toolbar": `toolbar_htPwT`,
	"toolbarLeft": `toolbarLeft_u2zqC`,
	"toolbarRight": `toolbarRight_HRLNc`,
	"toolbars": `toolbars_EGFDJ`,
	"container": `container_LNds3`,
	"details": `details_Rifu5`
};
export default ___CSS_LOADER_EXPORT___;
